import { render, staticRenderFns } from "./ActivateInfo.vue?vue&type=template&id=468cb30f&scoped=true"
import script from "./ActivateInfo.vue?vue&type=script&lang=js"
export * from "./ActivateInfo.vue?vue&type=script&lang=js"
import style0 from "./ActivateInfo.vue?vue&type=style&index=0&id=468cb30f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468cb30f",
  null
  
)

export default component.exports